import axios from "axios";
import { ApiKey, liveURL } from "../constants/Consts";

const API_URL = `${liveURL}/faq`;

export async function getFAQs() {
  try {
    const response = await axios.get(API_URL, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function createFAQ(data) {
  try {
    const response = await axios.post(API_URL, data, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function updateFAQ(id, data) {
  try {
    const response = await axios.put(`${API_URL}/${id}`, data, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function deleteFAQ(id) {
  try {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
} 